export const hideGames = [271000, 270, 272, 611007];
